<template>
  <div class="full">
    <Pipeline ref="pipeline" style="width: 100%; height: 100%;" v-if="toucher" :toucher="toucher" :useBloom="useBloom" :bloomPass="bloomPass">
      <template slot-scope="temp" slot="scene">
        <Particles :amount="200" v-if="temp" :engine="temp"></Particles>
        <!-- <LoadingGL :visible="true" @add-exec="(fn) => { temp.execStack.push(fn) }" :scene="temp.scene" :exec="temp.execStack" :renderer="temp.renderer"></LoadingGL> -->
      </template>
    </Pipeline>
    <div class="overlay" ref="toucher"></div>
    <div class="overlay" v-if="authMode === 'login'">
      <h1 class="center">BUHK Special System Login</h1>
      <div class="center">
        <input class="text-input" placeholder="username" type="text" v-model="loginData.username" />
        <br />
        <input  class="text-input" placeholder="password" type="password" v-model="loginData.password" />
        <br />
        <button class="text-input" @click="login()">Login</button>
      </div>
    </div>
    <!-- <div class="overlay" v-if="authMode === 'register'">
      <h1 class="center">BUHK Question Bank Register</h1>
      <div class="center">
        <input class="text-input" placeholder="username" type="text" v-model="loginData.username" />
        <br />
        <input  class="text-input" placeholder="password" type="password" v-model="loginData.password" />
        <br />
        <button class="text-input" @click="register()">Auto Login / Register</button>
      </div>
    </div> -->
  </div>
</template>

<script>
import * as Teacher from '@/api/teacher.js'

export default {
  components: {
    Pipeline: require('../game/Pipeline.vue').default,
    Particles: () => import('../game/Particles.vue'),
    // LoadingGL: () => import('../game/LoadingGL.vue'),
    // LoadingGL: require('../game/LoadingGL.vue').default
  },
  data () {
    return {
      authMode: 'login',
      loginData: {
        username: '',
        password: ''
      },
      toucher: false,
      useBloom: true,
      bloomPass: {
        threshold: 1,
      }
    }
  },
  mounted () {
    this.toucher = this.$refs.toucher
  },
  methods: {
    login () {
      let args = this.loginData
      Teacher.login(args)
        .then((data) => {
          window.localStorage.setItem('teacher-jwt', data.token)
          window.localStorage.setItem('teacher-uid', data.user._id)

          this.$router.push({
            path: '/buhk-admin-page',
            query: {
              ...this.$route.query,
            }
          })
        })
    },
    register () {
      let args = this.loginData
      Teacher.register(args)
        .then((data) => {
          console.log(data)
          window.localStorage.setItem('teacher-jwt', data.token)
          window.localStorage.setItem('teacher-uid', data.user._id)

          this.$router.push({
            path: '/buhk-admin-page',
            query: {
              ...this.$route.query,
            }
          })
        }, () => {
          this.login()
        })

    }
  }
}
</script>

<style scoped>
.overlay{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  color: white;
  /* background-color: red; */
}
.text-input{
  appearance: none;
  box-shadow: none;
  outline: none;
  border: none;
  background-color: white;
  border-bottom: white solid 3px;
  font-size: 30px;
  padding: 10px;
  margin: 10px;
}
.center{
  text-align: center;
}
</style>
